import { dsPublishVideoConfig } from './directive';

export { PublishVideoController } from './controller';
export { dsPublishVideoConfig } from './directive';

export const dsPublishVideoSID = 'dsPublishVideo';

angular.module('app').directive(dsPublishVideoSID, [() => dsPublishVideoConfig]);
